import { createApp } from 'vue'
import FHeart from '~/js/components/heart'
import { favouriteProductHandles } from '~/js/templates/index/helpers'

const ID_PRODUCT_PRICE_BOX = 'js-productPriceBox'

document.addEventListener('DOMContentLoaded', () => {
  const elementProductPriceBox = document.getElementById(ID_PRODUCT_PRICE_BOX)
  if (!elementProductPriceBox) return

  const handle = elementProductPriceBox.dataset.handle

  createApp({
    name: 'TemplatesProductPriceBox',
    components: { FHeart },
    data() {
      return {
        isFavorite: favouriteProductHandles.includes(handle),
      }
    },
    methods: {
      onHeartChanged($event) {
        this.isFavorite = $event
      },
    },
  }).mount(elementProductPriceBox)
})
